import { normalizeMobile } from "utils/normalize";

export const formatMobile = (mobile) => {
  const digits = normalizeMobile(mobile);

  if (!digits) {
    return null;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};